function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "img-lock");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u4FDD\\u5B58\\u5931\\u8D25\\u53CD\\u9988",
  transform: "translate(-790.000000, -940.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "lock",
  transform: "translate(790.000000, 940.000000)"
}, React.createElement("path", {
  d: "M2.058125,48.374375 C2.058125,50.444375 3.73625,52.124375 5.808125,52.124375 L50.28125,52.124375 C52.35125,52.124375 54.03125,50.444375 54.03125,48.374375 L54.03125,14.57 L2.058125,14.57 L2.058125,48.374375 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#F3F3F3"
}), React.createElement("path", {
  d: "M28.23875,25.11125 L18.558125,25.11125 C17.174375,25.11125 16.0775,24.025625 16.161875,22.735625 C16.165625,22.6775 16.1675,22.62125 16.1675,22.563125 L16.1675,22.533125 C16.16,21.224375 17.3,20.155625 18.7025,20.155625 L20.058125,20.155625 C21.730625,20.155625 23.088125,18.89 23.088125,17.328125 C23.088125,15.76625 21.730625,14.49875 20.058125,14.49875 L2.058125,14.49875 L2.058125,48.528125 C2.058125,50.6 3.73625,52.278125 5.808125,52.278125 L19.825625,52.278125 C21.5525,52.278125 22.94375,50.928125 22.851875,49.296875 C22.765625,47.766875 21.295625,46.62125 19.655,46.62125 L17.15,46.62125 C15.685625,46.62125 14.594375,45.47375 14.61125,44.106875 C14.61125,44.095625 14.61125,44.084375 14.61125,44.073125 C14.61125,44.061875 14.61125,44.050625 14.61125,44.039375 C14.594375,42.6725 15.685625,41.525 17.15,41.525 L23.3675,41.525 C25.094375,41.525 26.485625,40.175 26.39375,38.54375 C26.3075,37.01375 24.8375,35.868125 23.196875,35.868125 L19.881875,35.868125 C18.400625,35.868125 17.195,34.735625 17.2025,33.35375 L17.2025,33.32 L17.200625,33.156875 C17.19125,31.8425 18.33125,30.771875 19.74125,30.771875 L28.409375,30.771875 C30.13625,30.771875 31.5275,29.421875 31.435625,27.790625 C31.35125,26.256875 29.879375,25.11125 28.23875,25.11125 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#E8E8E8"
}), React.createElement("path", {
  d: "M57.813125,32.67375 C57.813125,26.863125 53.088125,22.138125 47.2775,22.138125 C41.466875,22.138125 36.74,26.865 36.74,32.67375 L36.74,44.97 L39.08375,44.97 L39.08375,32.675625 C39.08375,28.15125 42.75125,24.481875 47.275625,24.481875 C51.8,24.481875 55.4675,28.149375 55.4675,32.675625 L55.4675,44.97 L57.81125,44.97 L57.81125,32.67375 L57.813125,32.67375 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#C0BFBF"
}), React.createElement("path", {
  d: "M47.2775,24.481875 C42.753125,24.481875 39.085625,28.149375 39.085625,32.675625 L39.085625,44.97 L55.47125,44.97 L55.47125,32.675625 C55.469375,28.149375 51.801875,24.481875 47.2775,24.481875 Z M41.4275,40.280625 L41.4275,32.671875 C41.4275,29.446875 44.050625,26.82375 47.2775,26.82375 C50.5025,26.82375 53.125625,29.446875 53.125625,32.671875 L53.125625,40.280625 L41.4275,40.280625 Z",
  id: "\\u5F62\\u72B6",
  fill: "#CACACA"
}), React.createElement("path", {
  d: "M58.158125,38.200625 L36.396875,38.200625 C34.325,38.200625 32.646875,39.87875 32.646875,41.950625 L32.646875,58.2125 C32.646875,60.284375 34.325,61.9625 36.396875,61.9625 L58.158125,61.9625 C60.23,61.9625 61.908125,60.284375 61.908125,58.2125 L61.908125,41.950625 C61.908125,39.880625 60.23,38.200625 58.158125,38.200625 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#FDBC4B"
}), React.createElement("path", {
  d: "M61.896875,58.2125 L61.896875,41.950625 C61.896875,39.87875 60.216875,38.200625 58.146875,38.200625 L53.3225,38.200625 C52.270625,38.200625 51.415625,38.9975 51.415625,39.98 C51.415625,40.9625 52.26875,41.759375 53.3225,41.759375 L54.175625,41.759375 C55.056875,41.759375 55.775,42.4325 55.769375,43.255625 L55.769375,43.274375 C55.769375,43.31 55.77125,43.3475 55.773125,43.383125 C55.825625,44.195 55.135625,44.8775 54.265625,44.8775 L48.1775,44.8775 C47.14625,44.8775 46.22,45.599375 46.165625,46.56125 C46.1075,47.586875 46.98125,48.43625 48.06875,48.43625 L53.52125,48.43625 C54.408125,48.43625 55.124375,49.109375 55.11875,49.93625 L55.11875,50.039375 L55.11875,50.06 C55.124375,50.93 54.366875,51.6425 53.433125,51.6425 L51.35,51.6425 C50.31875,51.6425 49.3925,52.364375 49.338125,53.32625 C49.28,54.351875 50.15375,55.20125 51.24125,55.20125 L55.150625,55.20125 C56.07125,55.20125 56.7575,55.923125 56.748125,56.78375 C56.748125,56.79125 56.748125,56.79875 56.748125,56.804375 C56.748125,56.811875 56.748125,56.8175 56.748125,56.825 C56.759375,57.68375 56.073125,58.4075 55.150625,58.4075 L53.575625,58.4075 C52.544375,58.4075 51.618125,59.129375 51.56375,60.09125 C51.505625,61.116875 52.379375,61.96625 53.466875,61.96625 L58.145,61.96625 C60.21875,61.9625 61.896875,60.284375 61.896875,58.2125 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#FFCC5B"
}), React.createElement("path", {
  d: "M50.915,48.15125 C50.915,46.14125 49.285625,44.511875 47.275625,44.511875 C45.265625,44.511875 43.63625,46.14125 43.63625,48.15125 C43.63625,49.56125 44.448125,50.770625 45.62,51.374375 L44.834375,55.65125 L49.715,55.65125 L48.929375,51.374375 C50.105,50.770625 50.915,49.56125 50.915,48.15125 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#464646"
}), React.createElement("path", {
  d: "M54.03125,14.57 L54.03125,5.75 C54.03125,3.678125 52.35125,2 50.28125,2 L5.808125,2 C3.73625,2 2.058125,3.678125 2.058125,5.75 L2.058125,14.57 C2.058125,14.57 54.03125,14.57 54.03125,14.57 Z",
  id: "\\u8DEF\\u5F84",
  fill: "#6F7070"
}), React.createElement("circle", {
  id: "\\u692D\\u5706\\u5F62",
  fill: "#FFFFFF",
  cx: 8.883125,
  cy: 8.285,
  r: 2.420625
}), React.createElement("circle", {
  id: "\\u692D\\u5706\\u5F62",
  fill: "#E8E8E8",
  cx: 15.7175,
  cy: 8.285,
  r: 2.420625
}), React.createElement("circle", {
  id: "\\u692D\\u5706\\u5F62",
  fill: "#FDBC4B",
  cx: 22.551875,
  cy: 8.285,
  r: 2.420625
}))));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.2f54a115.svg";
export { ForwardRef as ReactComponent };